import { getCssKeyName, readCssVar } from "@Utils";
import { IPlanDropdown } from "./IPlanDropdown";

export const getCustomStyle = (
    isMobile: boolean = false
): IPlanDropdown.StyleType => {
    const themeColorValue = `rgb(${readCssVar(
        getCssKeyName("rgbColor1-schema1")
    )})`;

    const primaryColor = "#333333";

    const bgColor = "#ffffff";

    return {
        menu: provided => ({
            ...provided,
            marginTop: "2px",
            zIndex: 15,
            color: primaryColor,
        }),
        container: provided => ({
            ...provided,
            width: "100%",
            minWidth: isMobile ? "150px" : "50px",
        }),
        valueContainer: provided => ({
            ...provided,
            overflow: "visible",
            width: "fit-content",
            display: "inline-flex",
            "& input": {
                height: "0px!important",
            },
        }),
        singleValue: provided => ({
            ...provided,
            whiteSpace: "normal",
            position: "relative",
            transform: "translateY(0px)",
            maxWidth: "auto",
            top: "unset",
            fontWeight: 500,
            color: primaryColor,
        }),
        control: provided => ({
            ...provided,
            borderStyle: "solid",
            border: "2px solid #cccccc",
            "&:hover": {
                borderColor: themeColorValue,
            },
            boxShadow: "none",
            borderRadius: "8px",
            display: "flex",
            padding: isMobile ? "0" : "2px 0 2px 8px",
            backgroundColor: "white",
            color: !isMobile ? "transparent" : primaryColor || "#333",
        }),
        placeholder: provided => ({
            ...provided,
            color: primaryColor,
        }),
        option: (
            provided,
            {
                data,
                isSelected,
            }: { data: IPlanDropdown.OptionType; isSelected: boolean }
        ) => ({
            ...provided,
            ...(data.disabled && {
                textDecoration: "line-through",
                opacity: 0.5,
            }),
            padding: isMobile ? "4px 10px" : "4px 46px 4px 30px",
            fontWeight: 500,
            color: primaryColor,
            "&:hover": {
                ...(!data.disabled && {
                    opacity: 0.9,
                }),
            },
            ...(isSelected && {
                backgroundColor: primaryColor,
                color: bgColor,
            }),
        }),
        indicatorSeparator: provided => ({
            ...provided,
            opacity: 0,
        }),
        menuList: provided => ({
            ...provided,
        }),
        indicatorsContainer: provided => ({
            ...provided,
            "& svg": {
                color: `${primaryColor} !important`,
                marginLeft: isMobile ? "4px" : "16px",
            },
        }),
    };
};
